import { dev } from '$app/environment';

// 1. On définit strictement les types d'événements pour juslin.dev
export type AnalyticsEvent =
	| 'contact_start'
	| 'contact_success'
	| 'audit_session_request_start'
	| 'audit_session_request_success'
	| 'audit_session_request_failed'
	| 'newsletter_signup_start'
	| 'newsletter_signup_success'
	| 'newsletter_signup_failed'
	| 'project_view'
	| 'social_link_click'
	| 'devis_submitted'
	| '404_error';

interface EventParams {
	project_name?: string;
	platform?:
		| 'github'
		| 'linkedin'
		| 'x'
		| 'facebook'
		| 'youtube'
		| 'medium'
		| 'twitter'
		| 'instagram'
		| 'tiktok';
	method?: string;
	[key: string]: any;
}

/**
 * Service centralisé pour le tracking
 * Respecte la Clean Architecture en isolant l'appel à window.gtag
 */
export const trackEvent = (eventName: AnalyticsEvent, params?: EventParams) => {
	if (typeof window !== 'undefined' && window.gtag) {
		// En mode dev, on log dans la console pour débugger facilement
		if (dev) {
			console.log(`[Analytics Dev]: ${eventName}`, params);
		}

		window.gtag('event', eventName, {
			...params,
			// Le debug_mode permet de voir les événements dans la "DebugView" de GA4
			debug_mode: dev
		});
	}
};
